import React, { Component } from 'react'
import PropTypes from 'prop-types'

class VideoPlayer extends Component {
  state = { closeBtnHidden: false }

  hideImmersiveVideoBtnTimeout = null

  touchImmersiveScreenHandler = (e) => {
    if (e) e.stopPropagation()
    this.setState({ closeBtnHidden: false })

    // If touched again in less than 3 seconds, prevent previous timeout event from hiding it before 3s from now elapses
    if (this.hideImmersiveVideoBtnTimeout) clearTimeout(this.hideImmersiveVideoBtnTimeout)

    this.hideImmersiveVideoBtnTimeout = setTimeout(() => {
      this.setState({ closeBtnHidden: true })
    }, 3000)
  }

  componentDidMount() {
    // Initiate first timeout for hiding button after 3 seconds
    this.touchImmersiveScreenHandler()
  }

  componentWillUnmount() {
    if (this.hideImmersiveVideoBtnTimeout) clearTimeout(this.hideImmersiveVideoBtnTimeout)
  }

  render() {
    const fileExtensionRegex = /\.([^.]*)$/i
    const videoExtension = this.props.videoUrl.match(fileExtensionRegex)[1]

    return (
      <div
        className="player_immersive_video_wrapper"
        onClick={this.touchImmersiveScreenHandler}
      >
        <button
          className={`close_btn right_pos_mod player_immersive_video_close_btn width_mod ${
            this.state.closeBtnHidden ? 'hidden' : ''
          }`}
          onClick={this.props.closeImmersiveVideoHandler}
        ></button>
        <video
          playsInline
          loop={this.props.loop}
          muted={this.props.muted}
          className="player_immersive_video"
          poster={window?.cordova ? 'https://www.sound.care/' : null}
          ref={this.props.setVideoRef}
        >
          <source src={this.props.videoUrl} type={`video/${videoExtension}`} />
          Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
    )
  }
}

export default VideoPlayer

VideoPlayer.propTypes = {
  closeImmersiveVideoHandler: PropTypes.func.isRequired,
  attachCloseImmersiveBtnRef: PropTypes.func.isRequired,
  setVideoRef: PropTypes.func.isRequired,
  videoUrl: PropTypes.string.isRequired,
  loop: PropTypes.bool.isRequired,
  muted: PropTypes.bool.isRequired,
}
